import { render, staticRenderFns } from "./AddTalkModal.vue?vue&type=template&id=cb1a935e&scoped=true"
import script from "./AddTalkModal.vue?vue&type=script&lang=js"
export * from "./AddTalkModal.vue?vue&type=script&lang=js"
import style0 from "./AddTalkModal.vue?vue&type=style&index=0&id=cb1a935e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a935e",
  null
  
)

export default component.exports